import axios from 'axios'
import axiosRetry from 'axios-retry';
import router from '../router'
import store from '../store'
import { urlencode } from './common'

axios.defaults.withCredentials=true

axiosRetry(axios, {
  retries: 6,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (e) => {
		if(!e.response)
			return false;
		return e.response.status === 500 || e.response.status === 503 || e.response.status === 400
	}
});

export function requestApi (reqUrl, type = 'POST', data = {}, auth = '', multipart = false) {
  if (!reqUrl) { return }
  let headers = {}

  if (auth === 'distributor') {
    if (typeof (store.state.distributor) === 'undefined' || !store.state.distributor.token) {
      router.push({ name: 'DistributorLogin' })
    }
    headers['X-DS-KEY'] = store.state.distributor.token
  }
  if (auth === 'fuwu') {
    if (typeof (store.state.fuwu) === 'undefined' || !store.state.fuwu.token) {
      router.push({ name: 'FuwuLogin' })
    }
    headers['X-DS-KEY'] = store.state.fuwu.token
  }
  if (auth === 'member') {
    // if (typeof (store.state.member) === 'undefined' || !store.state.member.token) {
    //   router.push({ name: 'HomeLogin' })
    // }
    headers['X-DS-KEY'] = store.state.member.token
  }
  if (auth === 'seller') {
    if (typeof (store.state.seller) === 'undefined' || !store.state.seller.token) {
      router.push({ name: 'HomeSellerLogin' })
    }
    headers['X-DS-KEY'] = store.state.seller.token
  }
  if (multipart) {
    headers['Content-Type'] = 'multipart/form-data'
  }
  type = type.toUpperCase()
  reqUrl = process.env.VUE_APP_API_HOST + reqUrl
  let axiosData
  if (type === 'POST') {
    axiosData = {
      headers: headers,
      method: type,
      url: reqUrl,
      data: data
    }
  } else {
    if (JSON.stringify(data) !== '{}') {
      reqUrl += '?' + urlencode(data)
    }
    axiosData = {
      headers: headers,
      method: type,
      url: reqUrl
    }
  }
  return new Promise((resolve, reject) => {
    axios(axiosData).then(res => {
      if (res.data.code === 10000) {
        resolve(res.data)
      } else if (res.data.code === 11001) {
        store.commit('memberLogout')
        router.push({ name: 'HomeMemberLogin' }).catch(err => {})
      } else if (res.data.code === 20001) {
        store.commit('distributorLogout')
        router.push({ name: 'DistributorLogin' }).catch(err => {})
      } else if (res.data.code === 30001) {
        store.commit('fuwuLogout')
        router.push({ name: 'FuwuLogin' }).catch(err => {})
      } else if (res.data.code === 13001) {
        store.commit('sellerLogout')
        router.push({ name: 'HomeSellerLogin' }).catch(err => {})
      } else {
        reject(res.data)
      }
    }, error => {
      reject(error)
    })
  })
}
export function requestRaw (reqUrl, type = 'POST', data = {}, headers = {}) {
  type = type.toUpperCase()
  let axiosData
  if (type === 'POST') {
    axiosData = {
      method: type,
      url: reqUrl,
      data: data,
      headers: headers
    }
  } else {
    if (JSON.stringify(data) !== '{}') {
      reqUrl += '?' + urlencode(data)
    }
    axiosData = {
      method: type,
      url: reqUrl,
      headers: headers
    }
  }
  return new Promise((resolve, reject) => {
    axios(axiosData).then(res => {
      resolve(res.data)
    }, error => {
      reject(error)
    })
  })
}
